export default __webpack_public_path__ + "static/media/tbnail-04.png";